import axios from 'axios'
import { tokenService } from './token.service'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
})

apiClient.interceptors.request.use(
  config => {
    config.headers.Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return config
  },
  error => Promise.reject(error)
)

apiClient.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401) {
      const originalRequest = error.config
      if (!originalRequest.url?.includes('/auth/')) {
        tokenService.clear()

        const currentPath = window.location.pathname + window.location.search
        const redirectParam = encodeURIComponent(currentPath)
        window.location.href = `/auth/login?redirect=${redirectParam}`
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient
